<template>
    <div>
        <b-modal
        no-close-on-backdrop
        centered
        hide-header
        size="md"
        hide-footer
        v-model="open"
        >
        <section>
            <h1 class="c-orange text-center mb-3">Aviso!</h1>
            <span v-if="inConstruct">Ao alterar essa configuração, seu sistema passara a ficar em modo construção, não permitindo que clientes vejam produtos ou realizem alguma compra.</span>

            <span v-else>Ao desabilitar essa configuração, seu sistema ficara disponível, permitindo que clientes vejam produtos ou realizem compras.</span>
        </section>
        <div class="mt-5 d-flex justify-content-around">
            <b-button @click="modConstruct()" variant="success">Salvar</b-button>
            <b-button @click="toggleOpen(true)" variant="danger">Cancelar</b-button>
        </div>
        </b-modal>
    </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
    name: 'UnderConstructionModal',
    emits: ['getModal', 'inConstruction'],
    data() {
        return {
            open: false,
            isOpen: false,
        }
    },

    props: {
        inConstruct: {
            type: Boolean,
        },
        
        idShopkeeper: {
            type: Object
        },
    },

    methods: {
        ...mapActions('shopkeeper', ['saveModConstruct']),
        toggleOpen(isSave = false) {
            if (isSave) {
                this.$emit('inConstruction', false);
            }
            this.open = !this.open;
        },

        modConstruct() {
            this.toggleOpen();
            this.$store.dispatch('startLoader');
            this.loading = true;

            this.saveModConstruct({
                userId: this.idShopkeeper.id,
                isConstruct: this.inConstruct ? 1 : 0
            })
                .then(() => {
                    this.$emit('getModal');
                })
                .finally(() => {
                this.$store.dispatch('endLoader');
                this.loading = false;
                });
        },
    }
}
</script>